var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 74,
    viewBox: "0 0 364 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.293 0.292893C355.683 -0.0976311 356.317 -0.097631 356.707 0.292893L363.071 6.65685C363.462 7.04738 363.462 7.68054 363.071 8.07107C362.681 8.46159 362.047 8.46159 361.657 8.07107L356 2.41421L350.343 8.07107C349.953 8.46159 349.319 8.46159 348.929 8.07107C348.538 7.68054 348.538 7.04738 348.929 6.65685L355.293 0.292893ZM11 54.6911L346 54.6911L346 56.6911L11 56.6911L11 54.6911ZM355 45.6911L355 1L357 1L357 45.6911L355 45.6911ZM1.99998 65.6912L1.99998 74L-1.50077e-05 74L-1.6773e-05 65.6912L1.99998 65.6912ZM346 54.6911C350.971 54.6911 355 50.6617 355 45.6911L357 45.6911C357 51.7662 352.075 56.6911 346 56.6911L346 54.6911ZM11 56.6911C6.02943 56.6911 1.99998 60.7206 1.99998 65.6912L-1.6773e-05 65.6912C-1.80638e-05 59.616 4.92485 54.6911 11 54.6911L11 56.6911Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep108);
export default __webpack_public_path__ + "static/media/laptop_step_10_8.df5927724f65f56333176c7016ef589c.svg";
export { ForwardRef as ReactComponent };